import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=7be18e73&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be18e73')) {
      api.createRecord('7be18e73', component.options)
    } else {
      api.reload('7be18e73', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=7be18e73&", function () {
      api.rerender('7be18e73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/dashboard.vue"
export default component.exports